import { apiClient } from './api';
import { WorkSessionService } from './WorkSessionServiceBase';
export { WorkSessionService };
/**
 * Web work session service singleton instance
 * Uses standard web API client with cookie-based auth
 */
let _webWorkSessionService = null;
function getWebWorkSessionService() {
    if (!_webWorkSessionService) {
        _webWorkSessionService = new WorkSessionService(apiClient);
    }
    return _webWorkSessionService;
}
/**
 * Web work session service instance - exported for web app use
 */
export const workSessionService = getWebWorkSessionService();
